// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\r\n  position: relative;\r\n  height: 100%;\n}\n.el-dialog__body {\r\n  padding-top: 0px;\n}\n.el-table .success-row {\r\n  background: #f0f9eb;\n}\n.el-table__expanded-cell,\r\n.el-table__expanded-cell:hover {\r\n  background-color: cornsilk !important;\n}\n.el-table__expand-icon {\r\n  display: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
